import {useTranslation} from 'react-i18next'
import {useRoleUser} from '../../../hooks/useRoleUser'

export const RowHead = () => {
  const {t} = useTranslation()
  const roleUser = useRoleUser()

  return (
    <tr>
      <th>{t('No')}</th>
      {!roleUser.isSalesAnper && <th className='td-order-3 text-center'>Sales Org</th>}
      <th>{t('bahasa')}</th>
      <th>{t('Module')}</th>
      <th>{t('create_date')}</th>
      <th>{t('update_date')}</th>
      <th>{t('kontrak-aksi')}</th>
    </tr>
  )
}
